export const GERENCIALES_REPORT_TYPE = 'contract_details';
export const GERENCIALES_PAYMENTS_REPORT_TYPE = 'payments-report';
export const GERENCIALES_DEBT_BALANCE_REPORT_TYPE = 'debt-balance-report';
export const GERENCIALES_PERSONAL_DATA_REPORT_TYPE = 'personal-data-report';
export const GERENCIALES_APP_SUBSCRIBERS_REPORT_TYPE = 'mobile-app-subscribers-report';
export const GERENCIALES_ARCHIVED_CONTRACTS_REPORT_TYPE = 'archived-contracts-report';
export const GERENCIALES_LOTS_PROJECTS_REPORT_TYPE = 'lotes-proyectos';
export const GERENCIALES_ANNIVERSARY_PLAN_REPORT_TYPE = 'anniversary-plan-report';

export const GERENCIALES_DEBT_STATUS_VIEW_TABLE = 'table';
export const GERENCIALES_DEBT_STATUS_VIEW_CHART = 'chart';

export const GERENCIALES_DATE_RANGE_REPORTS = [GERENCIALES_PAYMENTS_REPORT_TYPE];
export const GERENCIALES_PDF_REPORTS = [
  GERENCIALES_REPORT_TYPE,
  GERENCIALES_PAYMENTS_REPORT_TYPE,
  GERENCIALES_APP_SUBSCRIBERS_REPORT_TYPE,
  GERENCIALES_ARCHIVED_CONTRACTS_REPORT_TYPE,
];

export const GERENCIALES_REPORT_OPTIONS = [
  {
    label: 'Detalle de contratos',
    value: GERENCIALES_REPORT_TYPE,
  },
  {
    label: 'Informe de Pagos',
    value: GERENCIALES_PAYMENTS_REPORT_TYPE,
  },
  {
    label: 'Informe de Saldos de Deuda',
    value: GERENCIALES_DEBT_BALANCE_REPORT_TYPE,
  },
  {
    label: 'Datos personales de Clientes',
    value: GERENCIALES_PERSONAL_DATA_REPORT_TYPE,
  },
  {
    label: 'Suscriptores en App celular',
    value: GERENCIALES_APP_SUBSCRIBERS_REPORT_TYPE,
  },
  {
    label: 'Motivos de baja de contratos',
    value: GERENCIALES_ARCHIVED_CONTRACTS_REPORT_TYPE,
  },
  {
    label: 'Lotes - Proyectos',
    value: GERENCIALES_LOTS_PROJECTS_REPORT_TYPE,
  },
  {
    label: 'Plan Aniversario',
    value: GERENCIALES_ANNIVERSARY_PLAN_REPORT_TYPE,
  },
];

export const PIE_ALLOWED_COLORS = [
  '#1e88e5',
  '#2e7d32',
  '#000000',
  '#e3e300',
  '#d32f2f',
  '#e29b00',
  '#00c5b2',
];

export const CHART_COLORS = {
  feeType: PIE_ALLOWED_COLORS,
  possession: PIE_ALLOWED_COLORS,
  clientType: PIE_ALLOWED_COLORS,
  feeTypePossession: PIE_ALLOWED_COLORS,
  clientTypePossession: PIE_ALLOWED_COLORS,
};

export const GERENCIALES_MESSAGES = {
  ERROR: {
    DATES_REQUIRED: 'Debe ingresar Fecha Desde y Fecha Hasta.',
    INVALID_RANGE: 'La fecha desde no puede ser mayor que la fecha hasta.',
  },
};

export const GERENCIALES_DEBT_STATUS_VIEW_OPTIONS = [
  { label: 'Tabla', value: GERENCIALES_DEBT_STATUS_VIEW_TABLE },
  { label: 'Gráfico', value: GERENCIALES_DEBT_STATUS_VIEW_CHART },
];

export const GERENCIALES_APP_USAGE_OPTIONS = [
  { label: 'Todos', value: 'all' },
  { label: 'Si', value: 'true' },
  { label: 'No', value: 'false' },
];
